import { Component, inject, OnInit } from '@angular/core';
import { TabelaSkeletonComponent } from '../shared/components/tabela-skeleton/tabela-skeleton.component';
import { MatTooltip } from '@angular/material/tooltip';
import { ButtonPadraoComponent } from '../shared/components/button-padrao/button-padrao.component';
import { FormFieldComponent } from '../shared/components/form-field/form-field.component';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Setor } from '../shared/model/setor/setor.model';
import { AuthService } from '../shared/service/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { MsgService } from '../shared/service/msg.service';
import { ValidacaoAlteracaoCampoService } from '../shared/service/utilitarios/validacao-alteracao-campo.service';
import { PaginatorComponent } from '../shared/components/paginator/paginator.component';
import { PageEvent } from '@angular/material/paginator';
import { SetorService } from '../shared/service/setor.service';
import { FiltroSetor } from '../shared/model/setor/setor-filtro.model';
import { ModalCadastroVisualizacaoSetorComponent } from './modal-cadastro-visualizacao-setor-component/modal-cadastro-visualizacao-setor-component.component';
import { debounceTime, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Ambiente } from '../shared/enum/ambiente.enum';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-setor',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    FormFieldComponent,
    ButtonPadraoComponent,
    MatTooltip,
    TabelaSkeletonComponent,
    PaginatorComponent
  ],
  templateUrl: './setor.component.html',
  styleUrl: './setor.component.css'
})
export class SetorComponent implements OnInit {

  setores: Setor[] = [];
  setoresFiltrados: Setor[] = [];

  dataSource = new MatTableDataSource<Setor>();
  carregandoSetores = false;

  displayedColumns: string[] = ['acao', 'id', 'status', 'nome', 'descricao', 'usuCriacao', 'dataCriacao', 'usuAlteracao', 'dataAlteracao'];

  //PAGINACAO
  page = 0;
  limit = 10;
  length = 0;

  filtroSetores: FiltroSetor = new FiltroSetor();
  searchSubject = new Subject<string>();

  isHml: boolean = environment.ambiente != Ambiente.PROD;

  private readonly authService = inject(AuthService);
  private readonly dialog = inject(MatDialog);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly setorService = inject(SetorService);
  private readonly msgService = inject(MsgService);
  private readonly alteracaoService = inject(ValidacaoAlteracaoCampoService);

  ngOnInit() {
    this.configurarDebounce();
    this.buscarSetores();
  }

  buscarSetores(){
    this.carregandoSetores = true;
    this.setorService.buscarSetores(this.filtroSetores, this.page, this.limit).subscribe({
      next: res => {
        this.setores = res.content;
        this.setoresFiltrados = res.content;
        this.dataSource = new MatTableDataSource(this.setores);
        this.length = res.totalElements;
      },
      error: () => {
        this.carregandoSetores = false
      },
      complete: () => {
        this.carregandoSetores = false
      }
    });
  }

  handlePageEvent(e: PageEvent) {
    this.page = e.pageIndex;
    this.limit = e.pageSize;

    this.buscarSetores();
  }

  filtrarSetores(valor: string) {
    this.searchSubject.next(valor);
  }

  configurarDebounce(): void {
    this.searchSubject
      .pipe(debounceTime(300))
      .subscribe(value => {
        this.filtroSetores.nome = value;
        this.buscarSetores()
      });
  }

  abrirModal(visualizar: boolean, setor?: Setor) {
    const dialogRef = this.dialog.open(ModalCadastroVisualizacaoSetorComponent, {
      width: '361px', height: '100vh',
      position: {
        top: '0',
        right: '0'
      },
      data: { visualizar, setor: {...setor} },
      panelClass: 'slide-modal',
      disableClose: !visualizar
    })

    if (!visualizar) {
      dialogRef.backdropClick().subscribe(() => {
        const podeFechar = !this.alteracaoService.isCamposAlteracao() ||
          window.confirm('Pode possuir alterações não salvas, deseja fechar?');
        if (podeFechar) { dialogRef.close(); }
      });
    }

    dialogRef.afterClosed().subscribe({
      next: res => {
        if (res) {
          this.setorService.salvarSetor(res.setor).subscribe({
            next: () => {
              this.zerarPaginacao();
              this.msgService.msgSucesso('Setor ' + (res.isCadastro ? 'salvo' : 'alterado') + ' com sucesso.');
            }
          });
        }
      }
    });
  }

  zerarPaginacao(){
    this.page = 0;
    this.limit = 10;
    this.length = 0;

    this.buscarSetores()
  }

}
